import axios from 'axios';

const axiosInstance = axios.create({
      // baseURL: 'http://192.168.1.5/decants/public/api',
      baseURL: 'http://scentures.com/backend/public/api',
  withCredentials: true
});

export default axiosInstance;